var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import DataTable from '@/components/data-table/DataTable';
import PageHeader from '@/components/page-header/PageHeader';
import AddGraduationProfileDialog from '@/views/GraduationProfiles/AddGraduationProfileDialog.vue';
import ErrorHandler from '@/support/ErrorHandler';
import { GraduationProfile } from '@/models/GraduationProfile';
let GraduationProfiles = class GraduationProfiles extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'GraduationProfiles';
        this.selected = [];
        this.isCreatingOrEditingGraduationProfile = false;
        this.selectedProfile = null;
    }
    onClickCreate() {
        this.selectedProfile = null;
        this.isCreatingOrEditingGraduationProfile = true;
    }
    get tableOptions() {
        return {
            name: {
                singular: this.$tc('Graduation profile'),
                plural: this.$tc('Graduation profiles'),
            },
            headers: [
                {
                    text: this.$t('name.title'),
                    value: 'name',
                    editable: false,
                    changed: false,
                },
                {
                    text: this.$t('Area'),
                    slot: 'subject',
                    value: 'subjects',
                    editable: false,
                    changed: false,
                },
                {
                    text: this.$t('Amount of topics'),
                    slot: 'subjects',
                    value: 'subjects',
                    editable: false,
                    changed: false,
                },
            ],
            actions: [
                {
                    type: 'edit',
                    label: 'edit',
                    icon: 'edit',
                    action: (vm, selectedProfile) => {
                        this.selectedProfile = selectedProfile;
                        this.isCreatingOrEditingGraduationProfile = true;
                    },
                },
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    action: (vm, selectedProfile) => {
                        this.selectedProfile = selectedProfile;
                        this.$store.dispatch('openDialog', this.dialogOptions);
                    },
                },
            ],
            filters: [],
            model: new GraduationProfile().include(['subject', 'subjects']),
        };
    }
    get dialogOptions() {
        const graduationProfile = this.selectedProfile;
        return {
            title: this.$tc('dialogOptions.confirmation').toString(),
            text: this.$tc('Attention: any assigned goals will be marked inactive. Are you sure that you want to delete this {item}? | Are you sure that you want to delete these {item}?', 1, { item: graduationProfile.name }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$tc('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!graduationProfile) {
                            return;
                        }
                        graduationProfile
                            .delete()
                            .then((response) => {
                            if (response) {
                                this.selectedProfile = null;
                                this.refreshDataTable();
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedProfile = null;
                    },
                },
            },
        };
    }
    refreshFilterStore() {
        new GraduationProfile()
            .all()
            .then((graduationProfiles) => {
            const mutatedGraduationProfiles = [];
            const payload = {};
            graduationProfiles.forEach((graduationProfile) => {
                mutatedGraduationProfiles.push({
                    value: graduationProfile.id,
                    text: graduationProfile.getFilterLabel(),
                });
            });
            payload.GraduationProfile = mutatedGraduationProfiles;
            this.$store.dispatch('updateFilters', payload);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    refreshDataTable() {
        this.isCreatingOrEditingGraduationProfile = false;
        this.refreshFilterStore();
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
};
GraduationProfiles = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            AddGraduationProfileDialog,
        },
    })
], GraduationProfiles);
export default GraduationProfiles;
